export const PERSONAL_ONBOARDING_BOOKING_URL = 'https://meetings-eu1.hubspot.com/mona-enterprise/mona-ai-ars-support';

export interface PersonalOnboardingOffer {
  titleDe: string;
  titleEn: string;
  bodyDe: string;
  bodyEn: string;
  ctaLabelDe: string;
  ctaLabelEn: string;
}

const DEFAULT_OFFER: PersonalOnboardingOffer = {
  titleDe: 'Persönliches Onboarding (15 Min.)',
  titleEn: 'Personal onboarding (15 min)',
  bodyDe: 'Lieber gemeinsam starten? Wir richten Ihre ARS-Umgebung in 15 Minuten gemeinsam mit Ihnen ein und beantworten alle Ihre Fragen.',
  bodyEn: 'Prefer to start together? We set up your ARS environment with you in 15 minutes and answer all your questions.',
  ctaLabelDe: '15-Min-Onboarding buchen',
  ctaLabelEn: 'Book 15-min onboarding'
};

const ARS_CAMPAIGN_BODIES: Record<string, { bodyDe: string; bodyEn: string }> = {
  'cv-filter': {
    bodyDe: 'Lieber gemeinsam starten? Wir richten in 15 Minuten Ihre Bewerber-Inbox und die automatische CV-Filterung gemeinsam mit Ihnen ein.',
    bodyEn: 'Prefer to start together? In 15 minutes we set up your applicant inbox and automatic CV filtering with you.'
  },
  'staffing': {
    bodyDe: 'Lieber gemeinsam starten? Wir richten in 15 Minuten Ihre Stellen, die ATS-Anbindung und den automatischen Kandidatenkontakt gemeinsam mit Ihnen ein.',
    bodyEn: 'Prefer to start together? In 15 minutes we set up your job offers, ATS connection and automatic candidate contact with you.'
  },
  'ats-search': {
    bodyDe: 'Lieber gemeinsam starten? Wir verbinden in 15 Minuten Ihr ATS und starten gemeinsam Ihre erste Datenbanksuche.',
    bodyEn: 'Prefer to start together? In 15 minutes we connect your ATS and run your first database search together.'
  },
  'ai-interviews': {
    bodyDe: 'Lieber gemeinsam starten? Wir richten in 15 Minuten Ihr erstes KI-Interview und die Telefonanbindung gemeinsam mit Ihnen ein.',
    bodyEn: 'Prefer to start together? In 15 minutes we set up your first AI interview and phone connection with you.'
  },
  'scheduling': {
    bodyDe: 'Lieber gemeinsam starten? Wir verbinden in 15 Minuten Ihren Kalender und Ihr Telefon für die automatische Terminierung.',
    bodyEn: 'Prefer to start together? In 15 minutes we connect your calendar and phone for automatic scheduling.'
  },
  'bulk-screening': {
    bodyDe: 'Lieber gemeinsam starten? Wir richten in 15 Minuten Ihre Bewerber-Inbox und das automatische Screening gemeinsam mit Ihnen ein.',
    bodyEn: 'Prefer to start together? In 15 minutes we set up your applicant inbox and automatic screening with you.'
  },
  'profile-creation': {
    bodyDe: 'Lieber gemeinsam starten? Wir richten in 15 Minuten Ihr KI-Interview und die automatische Profilerstellung gemeinsam mit Ihnen ein.',
    bodyEn: 'Prefer to start together? In 15 minutes we set up your AI interview and automatic profile creation with you.'
  }
};

export function getArsPersonalOnboardingOffer(campaignId: string | null | undefined): PersonalOnboardingOffer {
  const campaignBody = campaignId ? ARS_CAMPAIGN_BODIES[campaignId] : undefined;
  if (!campaignBody) return DEFAULT_OFFER;
  return { ...DEFAULT_OFFER, bodyDe: campaignBody.bodyDe, bodyEn: campaignBody.bodyEn };
}
